import { render, staticRenderFns } from "./AppTableEmptyBody.vue?vue&type=template&id=7153210f"
import script from "./AppTableEmptyBody.vue?vue&type=script&lang=js"
export * from "./AppTableEmptyBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports